import { Component, Input } from '@angular/core';
import { StatusPill } from '../../../../models/shared/status-pill';

@Component({
  selector: 'app-status-pill',
  standalone: true,
  templateUrl: './status-pill.component.html',
  styleUrls: ['./status-pill.component.scss']
})
export class StatusPillComponent {
  @Input() statusPill!: StatusPill;
}
